export class Controller {
  id!: string;
  name!: string;
  allId!: string;
  getId!: string;
  postId!: string;
  putId!: string;
  deleteId!: string;
}
